var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317 296c-3 3-8 3-11 0-3-4-3-9 0-12l73-73H138c-4 0-8-3-8-8 0-4 4-8 8-8h241l-73-73c-3-3-3-8 0-11s8-3 11 0c20 19 75 69 88 88 1 1 1 3 1 4 0 2 0 3-1 4-8 14-71 72-88 89zm-92 94c4 0 8 4 8 8 0 5-4 8-8 8H77c-25 0-38 0-49-5-5-3-9-6-13-10s-7-8-9-13l-1-1c-2-5-4-11-4-19-1-7-1-17-1-29V77c0-25 0-38 6-49 2-5 5-9 9-13s8-7 13-9c11-6 24-6 49-6h148c4 0 8 4 8 8 0 5-4 8-8 8H77c-23 0-34 0-42 4l-9 6-6 9c-4 8-4 19-4 42v252c0 12 0 21 1 28 0 6 1 10 3 13v1l6 9c3 3 6 5 9 6 8 4 19 4 42 4h148z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.22ae0a80189caa35e69a493e5a87daa3.svg";
export { ForwardRef as ReactComponent };